<template>
  <select class="form-control" v-model="selectedValue" @change="onChange">
    <option value="">(未選択)</option>
    <option v-for="code in codes" :value="code.code" :key="code.code">
      {{code.code}} : {{code.display_name}}
    </option>
  </select>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  codeGroup: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const store = useStore()
const codes = ref([])
const selectedValue = ref('')

// Computed
const getCodes = computed(() => store.getters['session/getCodes'])

// Methods
const onChange = (event) => {
  emit('update:modelValue', selectedValue.value)
  emit('change', event)
}

// Watchers
watch(() => props.modelValue, (newVal) => {
  selectedValue.value = newVal
})

// Lifecycle hooks
onMounted(() => {
  selectedValue.value = props.modelValue
  codes.value = getCodes.value(props.codeGroup)
})
</script>

<style scoped>

</style>
